import Field from "../Field";

export default class SystemSetupField extends Field {
    get type() {
        return 'radio-select';
    }
}
